// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/gnosis-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RPCResponseError
 */
export interface RPCResponseError {
    /**
     * 
     * @type {any}
     * @memberof RPCResponseError
     */
    data?: any | null;
    /**
     * 
     * @type {string}
     * @memberof RPCResponseError
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof RPCResponseError
     */
    code: number;
}

/**
 * Check if a given object implements the RPCResponseError interface.
 */
export function instanceOfRPCResponseError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function RPCResponseErrorFromJSON(json: any): RPCResponseError {
    return RPCResponseErrorFromJSONTyped(json, false);
}

export function RPCResponseErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): RPCResponseError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'message': json['message'],
        'code': json['code'],
    };
}

export function RPCResponseErrorToJSON(value?: RPCResponseError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'message': value.message,
        'code': value.code,
    };
}

